import { internalLinkUrl } from "../components/InternalLink/InternalLink";
import { SanityCallToAction } from "../model/common";

export const createLinkTo = (
  callToAction: SanityCallToAction,
  language: string
) => {
  const externalLink = callToAction?.externalLink?.href;
  const internalLink = callToAction?.internalLink?.reference;
  const query = callToAction?.internalLink?.query;
  const fragment = callToAction?.internalLink?.fragment;
  return internalLink
    ? internalLinkUrl(internalLink, query, fragment, language)
    : externalLink || "";
};
